import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Grid2 as Grid } from '@mui/material';
import { Link } from 'react-router-dom';

function ButtonViewAll({ href, variant = 'outlined' }: any) {
  return (
    <Grid
      container
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid>
        <Button variant={variant} color="primary" to={href} component={Link}>
          <FormattedMessage id="VIEW_ALL" />
        </Button>
      </Grid>
    </Grid>
  );
}

ButtonViewAll.ButtonViewAll = {
  href: PropTypes.string.isRequired,
};

export default ButtonViewAll;
